import { Vue, Component } from "vue-property-decorator";

@Component
export default class HacoCommon extends Vue {
  dialogText = "DIALOG";
  errorListText: string[] = [];
  confirmationText = "CONFIRMATION";
  dialogShows = false;
  confirmationShows = false;
  isErrorText = false;
  mounted(): void {
    this.dialogText = "Changed";
    this.confirmationText = "Confirmation Changed";
  }
  putErrorList(arr: string[]): void {
    this.errorListText = arr;
  }
  putDialogText(str: string): void {
    this.dialogText = str;
    this.dialogShows = true;
    this.isErrorText = false;
  }
  putErrorText(str: string): void {
    this.dialogText = str;
    this.dialogShows = true;
    this.isErrorText = true;
  }
  showSelections(str: string): void {
    console.log("showSelections", str);
    this.confirmationText = str;
    this.confirmationShows = true;
  }
  hideDialog(): void {
    this.dialogShows = false;
    this.confirmationShows = false;
  }
}
